import React from 'react';
import {
  ControlLabel,
  FormControl,
  FormGroup,
} from 'react-bootstrap';
import { Field } from 'redux-form';
import MaskedInput from 'react-text-mask';
import DropdownList from 'react-widgets/lib/DropdownList';

import createAutoCorrectedDatePipe from '../../../../utils/createAutoCorrectedDatePipe';
import TicketInputEnhanced from '../../../fields/TicketInput/containers/TicketInputEnhanced';
import EquipmentInput from './EquipmentInput';

export const PTO_TYPES = ['none', 'vacation', 'holiday', 'bereavement', 'unpaid'];

/* eslint-disable */
const createRenderer = (render) => ({ input, meta, label, controlLabelClassName, ...rest }) => {
  return (
    <div
      className={[
        meta.error && meta.touched ? 'form-error' : '',
        meta.active ? 'form-active' : '',
      ].join(' ')}
    >
      <ControlLabel className={controlLabelClassName}>
        {label}
      </ControlLabel>

      {render(input, label, rest)}

      {meta.error && meta.touched &&
      <span>
          {meta.error}
        </span>
      }
    </div>
  );
};
/* eslint-enable */

const RenderInput = createRenderer((input) => {
  return (
    <FormControl {...input} />
  );
});

const RenderDate = createRenderer((input) => {
  return (
    <FormControl
      componentClass={MaskedInput}
      placeholder="mm/dd/yyyy"
      mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
      pipe={createAutoCorrectedDatePipe('mm dd yyyy')}
      {...input}
    />
  );
});

export const DateInputField = () => {
  return (
    <FormGroup>
      <Field name="date" label="Date" component={RenderDate} />
    </FormGroup>
  );
};


const RenderPTODropdown = createRenderer((input, label, {
  disabled, data,
}) => {
  return (
    <DropdownList
      {...input}
      disabled={disabled}
      data={data}
    />
  );
});

export const PTOTypeInputField = (ptoDisabled) => {
  return (
    <FormGroup>
      <Field
        name="pto_type"
        label="PTO Type"
        data={PTO_TYPES}
        disabled={ptoDisabled}
        component={RenderPTODropdown}
      />
    </FormGroup>
  );
};

const RenderTicketInput = createRenderer((input, label, { disabled }) => {
  return (
    <TicketInputEnhanced
      assigned="attachable"
      disabled={disabled}
      {...input}
    />
  );
});

export const TicketInputField = (ticketNumberDisabled) => {
  return (
    <FormGroup>
      <Field
        name="ticket_number"
        type="select"
        label="Ticket Number"
        format={null}
        disabled={ticketNumberDisabled}
        component={RenderTicketInput}
      />
    </FormGroup>
  );
};

const RenderEquipmentInput = createRenderer((input, label, { disabled }) => {
  return (
    <EquipmentInput disabled={disabled} {...input} />
  );
});

export const EquipmentInputField = (equipmentDisabled) => {
  return (
    <FormGroup>
      <Field
        name="equipment"
        type="select"
        label="Equipment Number"
        format={null}
        disabled={equipmentDisabled}
        component={RenderEquipmentInput}
      />
    </FormGroup>
  );
};

const RenderTimeInput = createRenderer((input) => {
  return (
    <FormControl
      {...input}
      componentClass={MaskedInput}
      placeholder="HH:mm"
      guide={false}
      mask={[/\d/, /\d/, ':', /\d/, /\d/]}
      pipe={createAutoCorrectedDatePipe('HH:MM')}
    />
  );
});

export const StartTimeInputField = () => {
  return (
    <FormGroup>
      <Field name="start_time" type="text" label="Start Time" component={RenderTimeInput} />
    </FormGroup>
  );
};

export const EndTimeInputField = () => {
  return (
    <FormGroup>
      <Field name="end_time" type="text" label="End Time" component={RenderTimeInput} />
    </FormGroup>
  );
};

export const NotesInputField = () => {
  return (
    <FormGroup>
      <Field name="notes" type="text" label="Comments" component={RenderInput} />
    </FormGroup>
  );
};
